<!-- 
Contents of the INVOICING tab of the levy collection setup page.
-->
<template>
  <div class="home">
    <our-heading 
      :breadcrumbs="getBreadcrumbs('setup')"
      :subtitle="statusDescription"
      title="Setup"
      subtitle-tooltip="Levy collection status"
      user-guide-topic="levy-collection-setup"
      user-guide-section="invoice-template"
    >
      <template v-slot:navigator>
        <levy-collection-navigator :levy-collection-id="levyCollectionId" />
      </template>
    </our-heading>
    <tabs>
      <h3 class="title mb-0 ml-4 mt-4">
        Timing
        <our-user-guide-button topic="levy-collection-setup" section="timing-2" in-title/>
      </h3>
      <invoice-timing-configuration-panel :levy-collection-id="levyCollectionId" />
      <v-divider/>
      <h3 class="title mb-0 ml-4 mt-4">
        Payment details
        <our-user-guide-button topic="levy-collection-setup" section="payment-details" in-title/>
      </h3>
      <invoice-payment-details-configuration-panel :levy-collection-id="levyCollectionId" />
      <v-divider/>
      <sap-configuration-panel :levy-collection-type="levyCollection.type" />
      <v-divider/>
      <invoice-template-panel :levy-collection-id="levyCollectionId"/>
    </tabs>
  </div>
</template>

<script>
import levyCollectionSetupMixins from "./mixins";
import InvoiceTemplatePanel from "@/components/levy-collection-setup/InvoiceTemplatePanel.vue";
import InvoiceTimingConfigurationPanel from "@/components/levy-collection-setup/InvoiceTimingConfigurationPanel.vue";
import SapConfigurationPanel from "@/components/levy-collection-setup/SapConfigurationPanel.vue";
import InvoicePaymentDetailsConfigurationPanel from "@/components/levy-collection-setup/InvoicePaymentDetailsConfigurationPanel.vue";
import LevyCollectionNavigator from "@/components/levy-collections/LevyCollectionNavigator.vue";
import Tabs from "./Tabs.vue";

export default {
  components: {
    Tabs,
    LevyCollectionNavigator,
    InvoiceTemplatePanel,
    InvoiceTimingConfigurationPanel,
    SapConfigurationPanel,
    InvoicePaymentDetailsConfigurationPanel
  },
  mixins: [levyCollectionSetupMixins]
};
</script>
